
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RateMasterDialog extends Serenity.EntityDialog<RateMasterRow, any> {
        protected getFormKey() { return RateMasterForm.formKey; }
        protected getIdProperty() { return RateMasterRow.idProperty; }
        protected getLocalTextPrefix() { return RateMasterRow.localTextPrefix; }
        protected getService() { return RateMasterService.baseUrl; }
        protected getDeletePermission() { return RateMasterRow.deletePermission; }
        protected getInsertPermission() { return RateMasterRow.insertPermission; }
        protected getUpdatePermission() { return RateMasterRow.updatePermission; }
        protected useViewMode() { return true; }
        protected form = new RateMasterForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.FromWt);
            q.setTextRightAlign(this.form.ToWt);
            q.setTextRightAlign(this.form.PurStdRate);
            q.setTextRightAlign(this.form.SaleStdRate);
            this.form.ProductTypeId.changeSelect2(e => {
                this.form.CategoryId.ItemTypeId = 105;
                this.form.CategoryId.value = "";
                this.form.CategoryId.updateItems();
                this.form.ItemTypeId.value = "105";
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                q.showAndSetRequiredField(this.form.SubCategoryId);
            });

            this.form.SaleStdRate.changeSelect2(e => {
                if (this.form.PurStdRate.value > 0) {
                    if (this.form.SaleStdRate.value > 0 && this.form.SaleStdRate.value < this.form.PurStdRate.value) {
                        Q.warning("Sales Rate can not be less than Purchase Rate");
                        this.form.SaleStdRate.value = 0;
                        this.form.SaleStdRate.element.focus();
                    }
                }
            });

        }

        afterLoadEntity() {
            super.afterLoadEntity();
            this.setfields();
            if (Q.isEmptyOrNull(this.form.CategoryId.value)) {
                this.form.CategoryId.ItemTypeId = 105;
                this.form.CategoryId.updateItems();
                q.showAndDisableField(this.form.SubCategoryId);
            }
            this.form.ProductId.value = "0";
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
             
            return btns;
        }

        // #region Edit Delete Validation
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            let refid: OMS.RateMasterRow;
            OMS.RateMasterService.GetRate({
                ProductTypeId: parseInt(this.form.ProductTypeId.value)
                , CategoryId: parseInt(this.form.CategoryId.value)
                    ,ShapeId : parseInt(this.form.ShapeId.value)
                    ,QualityId : parseInt(this.form.QualityId.value)
                    ,StoneColorId : parseInt(this.form.StoneColorId.value)
                    ,SieveId : parseInt(this.form.SieveId.value)
                    ,StoneSizeId : parseInt(this.form.StoneSizeId.value) 
                    ,FromWT : this.form.FromWt.value
                    ,ToWT : this.form.ToWt.value
            }, 
                response => {
                    if (response.Entities != null && response.Entities.length > 0) {

                        Q.alert("Rate for Current Criteria is Already defined");
                        Isvalid = false;
                        return Isvalid;
}
                    
                }, { async: false });
            this.form.AttributeId.value = 0;
            return Isvalid;
        }

        setfields() {

            var StoneRateType = parseInt(TabAurous.GetConfigValue(1003));  
            switch (StoneRateType) {
                case 1:
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                    break;
                case 2://Shape, Quality
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.hideField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                    break;
                case 3://Shape, Color, Quality
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                    break;
                case 4://Shape, Color, Quality, Sieve
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                case 5://Shape, Color, Quality , Size
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    break;
                case 6://Color, Quality
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                    break;
                case 7://Color, Quality, Sieve
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.hideField(this.form.StoneSizeId);
                    break;

                case 8://Color, Quality, Size
                    q.showAndSetRequiredField(this.form.ProductTypeId);
                    q.showAndSetRequiredField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.hideField(this.form.SieveId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    break;


            }

        }


        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: PriceListDetailsRow;

            OMS.PriceListDetailsService.GetRate({
                AttributeId: this.form.AttributeId.value
            }, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    refid = response.Entities[0];
            }, { async: false });
            if (refid != null) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Rate is in use, Cannot delete");
                    return;
                }
            } else {
                RateMasterService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
    }

}